<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="rechargeRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-row class="text item">
          <el-form-item label="客户名称:">
            {{customername}}
          </el-form-item>
          <el-form-item prop="amount"
                        label="充值金额:">
            <el-input v-model="form.amount"
                      placeholder="请输入充值金额"></el-input>
          </el-form-item>
          <el-form-item prop="is_allow_invoice"
                        label="申请开票:">
            <el-select v-model="form.is_allow_invoice"
                       placeholder="请选择是否申请开票">
              <el-option :key="1"
                         label="允许"
                         :value="1"></el-option>
              <el-option :key="0"
                         label="不允许"
                         :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="imageurl"
                        label="上传转账证明:">
            <el-upload :limit="1"
                       :on-change="onChangeFile"
                       list-type="picture-card"
                       :on-remove="handleRemove"
                       :on-preview="handlePictureCardPreview"
                       ref="upload"
                       action=""
                       :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="imgDialogVisible">
              <img width="100%"
                   :src="form.img"
                   alt="爱零工">
            </el-dialog>
          </el-form-item>
          <el-form-item prop="desc"
                        label="备注:">
            <el-input type="textarea"
                      placeholder="请输入描述"
                      v-model="form.desc">
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary"
                     size="mini"
                     native-type="submit"
                     v-if="loading">保存
          </el-button>
          <router-link :to="{ path: '/teke_customer/recharge/table/'+form.customerid+'?customername=' + customername}">
            <el-button type="primary"
                       size="mini">取消
            </el-button>
          </router-link>
        </el-row>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { rechargeRules } from '../tekeCustomer.rules.js'

export default {
  data () {
    return {
      imgDialogVisible: false,
      loading: true,
      rechargeRules,
      selectLoading: false,
      customername: this.$route.query.customername,
      form: {
        customerid: this.$route.params.id,
        amount: null,
        is_allow_invoice: null,
        imageurl: [],
        desc: null,
      },

    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions(['createCustomeRecharge', 'UploadTekeFile']),

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.imageurl = this.form.imageurl[0]
          return request.common('createCustomeRecharge', this.form).then(({data}) => {
            this.$message({
              showClose: true,
              message: '创建成功',
              type: 'success',
            })
            this.loading = false
            window.location.href = '/teke_customer/recharge/table/' + this.form.customerid + '?customername=' + this.customername
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    handlePictureCardPreview (file) {
      this.form.img = file.url
      this.imgDialogVisible = true
    },
    onChangeFile (file, fileList) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.OnUploadFile(file.raw)
    },
    OnUploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.common('UploadTekeFile', formData).then(({data}) => {
        this.form.imageurl = []
        this.form.imageurl.push(data)
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
    handleRemove (file, fileList) {
      this.form.imageurl = []
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/teke-customer/pages/TekeCustomerRechargeForm.vue